import { render, staticRenderFns } from "./ActionTypeDivision.vue?vue&type=template&id=56dec28e&scoped=true"
import script from "./ActionTypeDivision.vue?vue&type=script&lang=js"
export * from "./ActionTypeDivision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dec28e",
  null
  
)

export default component.exports